// extracted by mini-css-extract-plugin
export var copyableItem = "_l-0";
export var underlined = "_l-1";